"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valtorta": {
    "32d88a81": [{
      "hkey": "1c8362cf",
      "slug": "valtorta",
      "name": "Valtorta",
      "primary": true,
      "skipSearch": false
    }],
    "grasso": [{
      "hkey": "1c8362cf",
      "slug": "valtorta",
      "name": "Valtorta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b9dd597": [{
      "hkey": "1c8362cf",
      "slug": "valtorta",
      "name": "Valtorta",
      "primary": true,
      "skipSearch": false
    }],
    "piani-di-valtorta": [{
      "hkey": "1c8362cf",
      "slug": "valtorta",
      "name": "Valtorta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3b6e12db": [{
      "hkey": "1c8362cf",
      "slug": "valtorta",
      "name": "Valtorta",
      "primary": true,
      "skipSearch": false
    }],
    "rava": [{
      "hkey": "1c8362cf",
      "slug": "valtorta",
      "name": "Valtorta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "998f96dc": [{
      "hkey": "1c8362cf",
      "slug": "valtorta",
      "name": "Valtorta",
      "primary": true,
      "skipSearch": false
    }],
    "cantello": [{
      "hkey": "1c8362cf",
      "slug": "valtorta",
      "name": "Valtorta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1a60978f": [{
      "hkey": "1c8362cf",
      "slug": "valtorta",
      "name": "Valtorta",
      "primary": true,
      "skipSearch": false
    }],
    "costa": [{
      "hkey": "1c8362cf",
      "slug": "valtorta",
      "name": "Valtorta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b9e82a10": [{
      "hkey": "1c8362cf",
      "slug": "valtorta",
      "name": "Valtorta",
      "primary": true,
      "skipSearch": false
    }],
    "fornovo": [{
      "hkey": "1c8362cf",
      "slug": "valtorta",
      "name": "Valtorta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;